"use client";

import LendingDAppPage from "../lending/[dapp]/page";

export default function LendPage() {
  return (
    <LendingDAppPage />
  );
}
